import React, {useEffect, useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import Table from "../../../shared/ui/table/table/Table";
import {TableData, TemplateTable} from "../../../shared/ui/table/models/TableProps";
import BtnDefault from "../../../shared/ui/button/default/BtnDefault";
import colorUtils from "../../../shared/colorUtils";
import IconButton from "../../../shared/ui/icon/IconBtn";
import FormAddCloseDay from "./components/FormAddCloseDay";
import ModalDeleteCloseDayConfirm from "./components/ModalDeleteCloseDayConfirm";
import http from "../../../shared/utils/http";
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../../core/reducer/pharmacySlice";
import {dateFormatGGmmYYYY, padNumber} from "../../../shared/utils/dateUtils";
import {addErrorMessage} from "../../../core/errors/errorSlice";
import {useAppDispatch} from "../../../app/hooks";


export const formatDate = ({day, month, year}: any) => {
    const date = new Date(year, month, day);
    return `${dateFormatGGmmYYYY(date)}`
};

const tableStructureTypeHours: TableData[] = [
    {
        name: "dayData",
        label: "Giorno",
    },
    {
        name: "action",
        label: "",
    },
];

export function CloseDays() {
    const [addCloseDay, setAddCloseDay] = useState<any | undefined>();
    const [deleteCloseDayModal, setDeleteCloseDayModal] = useState<any | undefined>();
    const pharmacy = useSelector(selectSelectedPharmacy)
    const dispatch = useAppDispatch();

    const [holidays, setHolidays] = useState<any[]>([])
    useEffect(() => {
        setHolidays([])
        pharmacy && http.get<{
            holidays: { day: number, month: number, year: number, all?: boolean, idPharmacy?: string }[]
        }>(`pharmacies/${pharmacy?.idDocument}/holidays`).then(res => {
            setHolidays(res?.holidays || [])
        }, err => {
            dispatch(addErrorMessage({title: 'Errore caricamento della lista dei giorni di chiusura. Riprova più tardi, grazie.'}))
        })
    }, [pharmacy]);

    const templates: TemplateTable = {
        dayData: (value: any, row: any) => (
            <span>{formatDate(row)}</span>
        ),
        action: (value: any, row: any) => (
            <div className={'d-flex justify-content-end gap-2'}>
                <BtnDefault icon={'./assets/icons/trash.svg'} variant={'outline-danger'}
                            tintColor={colorUtils.theme.red}
                            onClick={() => deleteCloseDay(row)} disabled={row?.all}
                            title={row?.all ? 'Giorno di default' : 'Cancella'}/>
            </div>
        )
    }

    const deleteCloseDay = (data: any) => {
        setDeleteCloseDayModal(data)
    }
    const confirmDelete = () => {
        http.delete(`pharmacies/${pharmacy?.idDocument}/holidays/${deleteCloseDayModal?.year}/${deleteCloseDayModal?.month}/${deleteCloseDayModal?.day}`).then(res => {
            setHolidays([...holidays.filter(ele => ele.idDocument !== deleteCloseDayModal.idDocument)])
            closeCloseDayModal()
        }, err => {
            dispatch(addErrorMessage({title: 'Errore nella cancellazione del giorno. Riprova più tardi, grazie.'}))
        })
    }
    const closeCloseDayModal = () => {
        setDeleteCloseDayModal(undefined)
    }

    const successActionHandler = (data: any) => {
        setHolidays([...holidays, {...data, dayData: `${data.year}-${padNumber(data.month)}-${padNumber(data.day)}`}])
        setAddCloseDay(undefined)
    }

    return (
        <AuthLayout>
            <div className="row">
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <h3>Lista giorni chiusura</h3>
                        <BtnPrimary icon={'./assets/icons/plus-c.svg'} onClick={() => setAddCloseDay({})}>Aggiungi
                            giorno chiusura</BtnPrimary>
                    </div>
                    <div className="col list-container">
                        <Table columns={tableStructureTypeHours}
                               data={holidays}
                               templates={templates} rowIndexActive={['0']}/>
                    </div>
                </div>
                {addCloseDay && <div className="col py-3 shadow">
                    <div>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <h3>Nuovo giorno di chiusura</h3>
                            <IconButton icon={'./assets/icons/close.svg'} size={'18px'}
                                        clickHandler={() => setAddCloseDay(undefined)}></IconButton>
                        </div>
                        <FormAddCloseDay closeFormHandler={() => setAddCloseDay(undefined)}
                                         successActionHandler={successActionHandler}/>
                    </div>
                </div>}
                {deleteCloseDayModal &&
                    <ModalDeleteCloseDayConfirm data={deleteCloseDayModal} confirmHandler={confirmDelete}
                                                closeHandler={closeCloseDayModal}/>}
            </div>
        </AuthLayout>
    );
}


